// src/admin/pages/Courses.jsx
import React, { useEffect, useMemo, useState } from "react";
import { adminService } from "../../services/adminService";
import { Link } from "react-router-dom";

const Courses = () => {
  const [courses, setCourses] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    async function load() {
      try {
        const data = await adminService.getCourses();
        setCourses(data);
      } catch (err) {
        console.error("Failed to load courses", err);
      }
    }
    load();
  }, []);

  const filteredCourses = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return courses;
    return courses.filter((c) => {
      return (
        String(c.title || "").toLowerCase().includes(q) ||
        String(c.slug || "").toLowerCase().includes(q)
      );
    });
  }, [courses, search]);

  return (
    <div className="space-y-8">

      {/* Page Header */}
      <h1 className="text-display">Courses</h1>

      <div className="bg-white shadow rounded-lg stakeholder-summary-card p-4 flex flex-col md:flex-row md:items-center gap-4">
        <input
          type="text"
          placeholder="Search by title or slug"
          className="border rounded-md px-3 py-2 text-sm w-full md:w-80"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <div className="text-sm text-muted md:ml-auto">
          Showing {filteredCourses.length} of {courses.length}
        </div>
      </div>

      {/* Table Card */}
      <div className="bg-white shadow rounded-lg stakeholder-summary-card p-6">
        <table className="w-full border-collapse text-[15px]">
          <thead>
            <tr className="border-b bg-gray-50">
              <Th>Title</Th>
              <Th>Slug</Th>
              <Th>Description</Th>
              <Th>Order</Th>
              <Th>Actions</Th>
            </tr>
          </thead>

          <tbody>
            {filteredCourses.map((c) => (
              <tr
                key={c.id}
                className="border-b hover:bg-gray-100 transition"
              >
                <Td className="font-semibold">{c.title}</Td>
                <Td className="text-muted">{c.slug}</Td>

                <Td className="max-w-lg text-[#323232]">
                  {c.description}
                </Td>

                <Td>{c.order}</Td>

                <Td>
                  <Link
                    to={`/admin/courses/${c.id}`}
                    className="text-[#54B0AF] font-semibold hover:underline"
                  >
                    View →
                  </Link>
                </Td>
              </tr>
            ))}

            {courses.length === 0 && (
              <tr>
                <td
                  colSpan="5"
                  className="text-center text-muted italic py-6"
                >
                  No courses found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Courses;

const Th = ({ children }) => (
  <th className="p-2 text-left text-title font-semibold">
    {children}
  </th>
);

const Td = ({ children, className = "" }) => (
  <td className={`p-2 ${className}`}>{children}</td>
);
